import { X } from "lucide-react";
import { useState } from "react";
import Moment from "react-moment";

const DetailsModal = ({ log, trigger }) => {
    const [isOpen, setIsOpen] = useState(false);
  
    const handleOpen = () => setIsOpen(true);
    const handleClose = () => setIsOpen(false);
    const formatKey = (key) => {
      // Convert camelCase to Sentence Case
      return key
        .replace(/([A-Z])/g, " $1") // Add space before capital letters
        .replace(/^./, (str) => str.toUpperCase()); // Capitalize the first letter
    };
    function isValidDate(value) {
      const dateFormats = [
        /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/, // ISO 8601 format (e.g., "2025-02-17T10:44:51.243Z")
        /^\d{4}-\d{2}-\d{2}$/, // Basic date format (e.g., "2025-02-17")
        /^\d{2}\/\d{2}\/\d{4}$/, // MM/DD/YYYY format (e.g., "02/17/2025")
        // Add more formats if necessary
      ];
    
      return dateFormats.some(format => format.test(value));
    }
    return (
      <>
        <div onClick={handleOpen}>{trigger}</div>
        {isOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto bg-black bg-opacity-50">
            <div className="relative w-full max-w-4xl mx-auto my-6">
              <div className="flex flex-col w-full bg-white rounded-lg shadow-lg">
                {/* Modal Header */}
                <div className="flex items-center justify-between p-5 border-b border-gray-200 rounded-t">
                  <h3 className="text-lg font-semibold text-gray-800">API Log Details</h3>
                  <button
                    className="text-gray-400 hover:text-gray-600"
                    onClick={handleClose}
                  >
                    <X className="w-5 h-5" />
                  </button>
                </div>
  
                {/* Modal Content (Scrollable) */}
                <div className="p-6 overflow-y-auto max-h-[60vh]">
                {Object.entries(log).map(([key, value]) => (
          <div key={key} className="mb-4">
            <div className="text-sm font-semibold text-gray-700">{formatKey(key)}:</div>
            <pre className="mt-1 text-sm text-gray-600 bg-gray-50 border border-gray-200 rounded p-2 overflow-auto">
  {typeof value === "object" ? (
    JSON.stringify(value, null, 2)
  ) : typeof value === "boolean" ? (
    value ? "True" : "False"
  ) : isNaN(Date.parse(value)) || !isValidDate(value) ? (
    value
  ) : (
    <Moment format="DD MMM YYYY hh:mm:ss A">{value}</Moment>
  )}
</pre>

          </div>
        ))}
    </div>

  
                {/* Modal Footer */}
                <div className="flex items-center justify-end p-4 border-t border-gray-200 rounded-b">
                  <button
                    className="px-4 py-2 text-sm font-medium text-white bg-gray-600 rounded hover:bg-gray-700"
                    onClick={handleClose}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  };
  export default DetailsModal